import script from "./WCSvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCSvgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./WCSvgIcon.vue?vue&type=style&index=0&id=3f1d36a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1d36a4"]])

export default __exports__